import type {FC} from 'react';
import type {SanityImage} from '@selvklart/sanity-next-image';
import clsx from 'clsx';

import {ImageFillClient} from 'components/image/client';
import type {PosterHeadingSchema} from 'components/page-heading/poster-heading/schema';

interface Props {
	data: PosterHeadingSchema;
}

export const PosterHeading: FC<Props> = ({data: {image, title}}) => {
	return (
		<div>
			<h1 className={clsx('sr-only')}>{title}</h1>
			<div className={clsx('relative', 'xl:h-[750px]', 'max-xl:aspect-[2/1]')}>
				{image && image.asset && (
					<ImageFillClient image={image as SanityImage} alt={title ?? ''} />
				)}
			</div>
		</div>
	);
};
